import { DefaultI18nValues } from './types';

export const defaultI18nPt: DefaultI18nValues = {
	'general.ok': 'Ok',
	'simulator.modals.genericError.title': 'Ups, não conseguimos processar o seu pedido.',
	'simulator.modals.genericError.pleaseTryAgain': 'Por favor, tente mais tarde.',
	'simulator.modals.genericError.exit': 'Sair',
};
